import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20interior%20with%20large%20screen%20displaying%20vibrant%20colorful%20abstract%20visuals%2C%20dark%20ambient%20lighting%20with%20warm%20golden%20accents%2C%20luxurious%20velvet%20seats%2C%20dramatic%20atmosphere%2C%20professional%20cinema%20photography%2C%20rich%20deep%20colors&width=1600&height=900&seq=madou-hero-bg&orientation=landscape"
        alt="麻豆cm传媒在线高清 - 官方正版高清视频平台"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-background-50/15 backdrop-blur-sm rounded-full px-4 py-1.5 mb-6">
          <i className="ri-sparkling-2-fill text-accent-400 text-sm"></i>
          <span className="text-background-50/90 text-xs md:text-sm font-medium">官方正版高清视频平台  ·  海量资源免费观看</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight">
          麻豆cm传媒<span className="text-accent-400">在线高清</span>
        </h1>
        <p className="text-background-50/80 text-sm md:text-lg max-w-[650px] mx-auto mb-8 leading-relaxed">
          最新高清视频内容，画质清晰流畅，海量资源免费在线观看。支持多终端播放，随时随地享受极致高清视听体验。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/all"
            className="bg-primary-500 hover:bg-primary-600 text-background-50 font-medium px-8 py-3 rounded-full text-sm whitespace-nowrap transition-all cursor-pointer inline-flex items-center gap-2"
          >
            <i className="ri-play-circle-fill text-lg"></i>
            立即观看
          </Link>
          <Link
            to="/about"
            className="bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm text-background-50 font-medium px-8 py-3 rounded-full text-sm whitespace-nowrap transition-all cursor-pointer border border-background-50/20"
          >
            了解更多
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10">
          {[
            { value: '10万+', label: '高清资源' },
            { value: '4K', label: '超清画质' },
            { value: '5000万+', label: '活跃用户' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">{stat.value}</p>
              <p className="text-xs md:text-sm text-background-50/60 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}